<div *ngIf="pay && configSetupData && loaded" class="payline-table-container">
  <div *ngFor="let line of paylines">
    <div class="d-flex">
      <div class="justify-content-start">
        <strong>{{ pay.EmployeeLastName }}, {{ pay.EmployeeFirstName }}</strong>
      </div>
      <div *ngIf="payrollMgmt.periodEndDisplay(payroll, true) == 'Multiple'" class="ms-5">
        Period End Date: {{ line.PeriodEndOverride || pay.PeriodEnd | date: 'MM/dd/yyyy' }}
      </div>
      <!-- task 13578 -->
      <div
        *ngIf="
          line.PaylineType === paylineType.Manual ||
          line.PaylineType == paylineType.NoCheck ||
          payroll.PayType == payTypes.Manual
        "
        class="flex-fill text-end">
        <strong>NO CHECK</strong>
      </div>
      <div
        *ngIf="line.PaylineType === paylineType.Void || payroll.PayType == payTypes.Adjustment"
        class="flex-fill text-end">
        <strong>VOID</strong>
      </div>
    </div>
    <!-- user story 7224 -->
    <table class="table table-sm fixed-width mb-4">
      <thead>
        <tr>
          <th rowspan="2"></th>
          <th rowspan="2" class="text-start">
            Earn<br />
            Name
          </th>
          <th rowspan="2" class="text-end">
            Rate/<br />
            Amount
          </th>
          <th colspan="2" class="ps-5 pb-0">Current</th>
          <th colspan="2" class="ps-5 pb-0">YTD</th>
          <th rowspan="2" class="text-start">
            Tax<br />
            Name
          </th>
          <th rowspan="2">W-4</th>
          <th rowspan="2" class="text-end">
            Current<br />
            Amount
          </th>
          <th rowspan="2" class="text-end">
            YTD<br />
            Amount
          </th>
          <th rowspan="2" class="text-start">
            Ded<br />
            Name
          </th>
          <th rowspan="2" class="text-end">
            Current<br />
            Amount
          </th>
          <th rowspan="2" class="text-end">
            YTD<br />
            Amount
          </th>
          <th rowspan="2" class="text-start">Desc</th>
          <th rowspan="2" class="text-end">Amount</th>
        </tr>
        <tr class="border-bottom-grey">
          <th class="text-end">Hrs</th>
          <th class="text-end">Amount</th>
          <th class="text-end">Hrs</th>
          <th class="text-end">Amount</th>
        </tr>
      </thead>
      <tbody>
        <!-- details row -->
        <tr class="border-bottom-grey">
          <td class="border-right-grey">
            Emp: {{ pay.EmployeeNumber }}
            <div *ngIf="pay.DivisionId">Div: {{ getDivisionName(pay.DivisionId) }}</div>
            <div *ngIf="pay.DepartmentId">
              Dept: {{ getDepartmentName(pay.DivisionId, pay.DepartmentId) }}
            </div>
            <div>
              {{
                line.PayFrequencyTaxOverride
                  ? payrollFrequencies[line.PayFrequencyTaxOverride]
                  : payrollFrequencies[pay.PayFrequency]
              }}
            </div>
          </td>
          <!--
            bug 7857. display 0 if temporary/permanent amounts are 0.
            do not render anything if amount is null. passing null to
            the number pipe returns nothing.
          -->
          <!-- earnings -->
          <td>
            <div *ngFor="let earn of line.Earnings">
              <span
                [ngClass]="{
                  'fst-italic':
                    earn.TemporaryRateAmount != null &&
                    earn.TemporaryRateAmount != earn.PermanentRateAmount
                }">
                {{ getEarningName(earn.EarningId) }}
              </span>
            </div>
          </td>
          <td class="text-end">
            <div *ngFor="let earn of line.Earnings">
              &nbsp;
              <span
                [ngClass]="{
                  'fst-italic':
                    earn.TemporaryRateAmount != null &&
                    earn.TemporaryRateAmount != earn.PermanentRateAmount
                }">
                {{
                  (earn.TemporaryRateAmount != null
                    ? earn.TemporaryRateAmount
                    : earn.PermanentRateAmount
                  ) | number: '1.2-2'
                }}
              </span>
            </div>
          </td>
          <td class="text-end">
            <div *ngFor="let earn of line.Earnings">
              &nbsp;
              {{ earn.Hours | number: '1.2-2' }}
            </div>
          </td>
          <td class="text-end">
            <div
              *ngFor="let earn of line.Earnings"
              [ngClass]="{
                'fst-italic':
                  earn.TemporaryRateAmount != null &&
                  earn.TemporaryRateAmount != earn.PermanentRateAmount
              }">
              &nbsp;
              {{ earn.CurrentAmount | number: '1.2-2' }}
            </div>
          </td>
          <td class="bg-grey text-end">
            <div *ngFor="let earn of line.Earnings">
              &nbsp;
              {{ earn.YTDHours || 0 | number: '1.2-2' }}
            </div>
          </td>
          <td class="bg-grey text-end border-right-grey">
            <div *ngFor="let earn of line.Earnings">
              &nbsp;
              {{ earn.YTDAmount || 0 | number: '1.2-2' }}
            </div>
          </td>
          <!-- taxes -->
          <td>
            <div *ngFor="let tax of line.Taxes">
              &nbsp;
              <span [ngClass]="{ 'fst-italic': tax.TemporaryAmount != null }">
                {{ tax.TaxCode }}
              </span>
            </div>
          </td>
          <td class="text-center">
            <div *ngFor="let tax of line.Taxes">
              {{ tax.FilingStatus }}&nbsp;{{ tax.Allowances }}
            </div>
          </td>
          <td class="text-end">
            <div *ngFor="let tax of line.Taxes">
              &nbsp;
              <span [ngClass]="{ 'fst-italic': tax.TemporaryAmount != null }">
                {{ tax.CurrentAmount | number: '1.2-2' }}
              </span>
            </div>
          </td>
          <td class="bg-grey text-end border-right-grey">
            <div *ngFor="let tax of line.Taxes">
              &nbsp;
              {{ tax.YTDAmount || 0 | number: '1.2-2' }}
            </div>
          </td>
          <!-- deductions -->
          <td>
            <div *ngFor="let ded of line.Deductions">
              <span
                [ngClass]="{
                  'fst-italic':
                    (ded.TemporaryAmount != null && ded.TemporaryAmount != ded.PermanentAmount) ||
                    (ded.TemporaryRate != null && ded.TemporaryRate != ded.PermanentRate)
                }">
                {{ getDeductionName(ded.DeductionCode) }}
              </span>
            </div>
          </td>
          <td class="text-end">
            <div *ngFor="let ded of line.Deductions">
              &nbsp;
              <span
                [ngClass]="{
                  'fst-italic':
                    (ded.TemporaryAmount != null && ded.TemporaryAmount != ded.PermanentAmount) ||
                    (ded.TemporaryRate != null && ded.TemporaryRate != ded.PermanentRate)
                }">
                {{ ded.CurrentAmount | number: '1.2-2' }}
              </span>
            </div>
          </td>
          <td class="bg-grey text-end border-right-grey">
            <div *ngFor="let ded of line.Deductions">
              &nbsp;
              {{ ded.YTDAmount || 0 | number: '1.2-2' }}
            </div>
          </td>
          <!-- check info -->
          <td>
            <div>Net</div>
            <ng-container
              *ngIf="
                line.PaylineType !== paylineType.Manual &&
                payroll.PayType != payTypes.Manual &&
                line.PaylineType != paylineType.Void &&
                payroll.PayType != payTypes.Adjustment
              ">
              <div *ngIf="line.NetCheckAmountPaid">Check</div>
              <div *ngIf="line.NetAmountDeposited">Deposited</div>
            </ng-container>
            <div *ngIf="line.OverrideCheckNumber">Check No.</div>
          </td>
          <td class="text-end">
            <div>
              {{ line.NetAmountPaid | number: '1.2-2' }}
            </div>
            <ng-container
              *ngIf="
                line.PaylineType !== paylineType.Manual &&
                payroll.PayType != payTypes.Manual &&
                line.PaylineType != paylineType.Void &&
                payroll.PayType != payTypes.Adjustment
              ">
              <div *ngIf="line.NetCheckAmountPaid">
                {{ line.NetCheckAmountPaid | number: '1.2-2' }}
              </div>
              <div *ngIf="line.NetAmountDeposited">
                {{ line.NetAmountDeposited | number: '1.2-2' }}
              </div>
            </ng-container>
            <div *ngIf="line.OverrideCheckNumber">
              {{ checkNumberDisplay(line.OverrideCheckNumber) }}
            </div>
          </td>
        </tr>
        <!-- totals row -->
        <tr>
          <th colspan="2">QTD Gross: {{ line.QTDEarningsGross || 0 | number: '1.2-2' }}</th>
          <th>Gross:</th>
          <th class="text-end">
            {{ line.EarningsTotalCurrentHours || 0 | number: '1.2-2' }}
          </th>
          <th class="text-end">
            {{ line.EarningsTotalCurrentAmount || 0 | number: '1.2-2' }}
          </th>
          <th class="text-end bg-grey">
            {{ line.EarningsTotalYTDHours || 0 | number: '1.2-2' }}
          </th>
          <th class="text-end bg-grey border-right-grey">
            {{ line.EarningsTotalYTDAmount || 0 | number: '1.2-2' }}
          </th>
          <th class="text-end" colspan="3">
            {{ line.TaxesTotalCurrentAmount || 0 | number: '1.2-2' }}
          </th>
          <th class="bg-grey border-right-grey">&nbsp;</th>
          <th>
            <span *ngIf="line.DeductionsTotalAmount != null"> EE Deds: </span>
          </th>
          <th class="text-end">
            {{ line.DeductionsTotalAmount | number: '1.2-2' }}
          </th>
          <th class="bg-grey border-right-grey">&nbsp;</th>
          <th colspan="2">&nbsp;</th>
        </tr>
      </tbody>
    </table>
  </div>
</div>
